<p-toast/>
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto modal-scrollbar">
        <div class="p-8">
            <div class="text-center mb-8">
                <a routerLink="/">
                <img src="/assets/images/logos/Hector_Group_Logo_Black.jpg" alt="Hector Group Logo" class="w-25 h-25 mx-auto mb-4 rounded-full object-cover" />
               
               </a> <h2 class="text-2xl font-bold text-gray-900 mb-2">
                    Admin Login
                </h2>
                <p class="text-gray-600">
                    Access the admin dashboard
                </p>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
                <!-- Email -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        Email Address
                    </label>
                    <div class="relative">
                        <i-lucide name="mail" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input type="email" formControlName="email" class="w-full pl-10 pr-4 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="admin@email.com" />
                    </div>
                </div>

                <!-- Password -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                        Password
                    </label>
                    <div class="relative">
                        <i-lucide name="lock" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="w-full pl-10 pr-12 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="••••••••"
                        />
                        <button type="button" (click)="togglePasswordVisibility()" class="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
                            <i-lucide [name]="showPassword ? 'eye-off' : 'eye'" class="h-7 w-5"></i-lucide>
                        </button>
                    </div>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg flex items-center justify-center" [disabled]="loading">
                    {{ loading ? 'Processing...' : 'Sign In' }}
                    <i-lucide *ngIf="!loading" name="arrow-right" class="ml-2 h-5 w-5"></i-lucide>
                </button>
            </form>

            <!-- Security Notice -->
            <!-- <div class="mt-6 pt-6 border-t border-gray-200">
                <div class="flex items-center justify-center text-sm text-gray-500">
                    <i-lucide name="shield" class="h-4 w-4 mr-2"></i-lucide>
                    Secured by 256-bit SSL encryption
                </div>
            </div> -->
        </div>
    </div>
</div>